"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useValuesStoredInParams = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _queryString = _interopRequireDefault(require("query-string"));
var _usePrevious = require("../usePrevious/usePrevious");
var useUrl = function useUrl() {
  var location = (0, _reactRouterDom.useLocation)();
  return "".concat(location.pathname).concat(location.search);
};
var useValuesStoredInParams = function useValuesStoredInParams(values) {
  var navigate = (0, _reactRouterDom.useNavigate)();
  var location = (0, _reactRouterDom.useLocation)();
  var params = new URLSearchParams(location.search).toString();
  var paramsObject = Object.fromEntries(Object.entries(values).filter(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      param = _ref2[1];
    return param.value !== param.defaultValue;
  }).map(function (_ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
      key = _ref4[0],
      param = _ref4[1];
    return [key, param.value];
  }));
  var stringifiedParams = _queryString.default.stringify(paramsObject);
  var url = useUrl();
  var previousUrl = (0, _usePrevious.usePrevious)(url);
  (0, _react.useEffect)(function () {
    // there was a user navigation within the app
    if (previousUrl && previousUrl !== url) {
      return;
    }
    if (params !== stringifiedParams) {
      navigate({
        search: stringifiedParams,
        pathname: location.pathname
      });
    }
  }, [stringifiedParams, params, location.pathname, previousUrl, url, navigate]);
};
exports.useValuesStoredInParams = useValuesStoredInParams;